<template>
    <div>
        <div class="content mt-20">
            <smart-table :table-label="labels" :table-data="searchData.list" :table-opt="opt"></smart-table>
        </div>
        <div class="flex flex-right mt-20">
            <pagination :page="searchParams.page" :pages="searchData" @on-search="toPage"></pagination>
        </div>
    </div>

</template>

<script>
    import Pagination from "../../components/Pagination";
    import SmartTable from "../../components/SmartTable";
    const typeMap = {
            1:'集中器导出',
            2:'用户导出',
            3:'充值记录导出',
            4:'日抄表记录导出',
            5:'月用电记录导出',
            6:'监控记录导出',
        }

    const statusMap = {
        1:'等待中',
        2:'下载中',
        3:'完成',
    }
    export default{
        components: {
            SmartTable,
            Pagination,
        },
        data(){
            return {
                searchParams: {
                    page: 1
                },
                searchData: {},
                opt: [
                    {label:'下载',fn:this.downloadFile,dis:[1,2],disprop:'status'}

                ],
                labels: [
                    {prop: 'type', label: '任务名',map:typeMap},
                    {prop: 'totalCount', label: '总数量'},
                    {prop: 'completeCount', label: '已完成'},
                    {prop: 'createAt', label: '时间'},
                    {prop: 'status', label: '状态',map:statusMap},
                ],
                temp:{},
                timer:null,

            }
        },
        computed:{
            list(){
                let  arr = []
                for(var i in this.$store.state.tasKeyMap){
                    arr.push({id:i,name:this.$store.state.tasKeyMap[i]})
                }
                return arr
            },

        },
        mounted(){
            this.getList()
            this.timer = setInterval(() => {
                this.getList()
            },10*1000)

        },
        beforeDestroy(){
          clearInterval(this.timer)
          this.timer = null
        },
        methods: {
            search(stop){
                this.searchParams.page = 1
                this.getList(stop)
            },
            toPage(page){
                this.searchParams.page = page
                this.getList()
            },
            getList(callback){
                this.$http$({method: 'get', url: "/smartMeter/export/exportTask",data:this.searchParams,  load: 1}, (data) => {
                    callback ? callback() : ''
                    this.searchData = data
                })
            },
            downloadFile(obj){
                this.$export('excelExport/'+obj.url)
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/admin/DownloadTask.vue